<template>
  <div class="role-management">
    <!-- 搜索栏 -->
    <el-card class="search-card">
      <el-form :inline="true" :model="searchForm" class="search-form">
        <el-form-item label="角色名称">
          <el-input v-model="searchForm.name" placeholder="请输入角色名称" clearable style="width: 180px;"></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="searchForm.status" placeholder="请选择" clearable style="width: 140px;">
            <el-option label="启用" :value="1"></el-option>
            <el-option label="禁用" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch" icon="el-icon-search">查询</el-button>
          <el-button @click="handleReset" icon="el-icon-refresh">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 表格区域 -->
    <el-card class="table-card">
      <div slot="header" class="clearfix">
        <span>角色列表</span>
        <el-button style="float: right;" type="primary" size="small" icon="el-icon-plus" @click="handleAdd">新增角色</el-button>
      </div>

      <el-table :data="tableData" border stripe v-loading="tableLoading">
        <el-table-column prop="id" label="ID" width="70"></el-table-column>
        <el-table-column prop="name" label="角色名称" min-width="120"></el-table-column>
        <el-table-column prop="code" label="角色编码" min-width="140">
          <template slot-scope="scope">
            <el-tag type="info" size="small">{{ scope.row.code }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="description" label="描述" min-width="180" show-overflow-tooltip></el-table-column>
        <el-table-column prop="statusName" label="状态" width="90">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 1 ? 'success' : 'danger'" size="small">
              {{ scope.row.statusName }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="170">
          <template slot-scope="scope">{{ formatDate(scope.row.createTime) }}</template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="220">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button type="text" size="small" @click="handleBindMenu(scope.row)">绑定菜单</el-button>
            <el-button
              type="text"
              size="small"
              :type="scope.row.status === 1 ? 'warning' : 'success'"
              @click="handleToggleStatus(scope.row)"
            >
              {{ scope.row.status === 1 ? '禁用' : '启用' }}
            </el-button>
            <el-button
              v-if="scope.row.id !== 1"
              type="text"
              size="small"
              @click="handleDelete(scope.row)"
              style="color: #F56C6C;"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        @current-change="handlePageChange"
        :current-page="pagination.pageNum"
        :page-size="pagination.pageSize"
        :total="pagination.total"
        layout="total, prev, pager, next"
        style="margin-top: 20px; text-align: right;">
      </el-pagination>
    </el-card>

    <!-- 新增/编辑对话框 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="520px"
      @close="handleDialogClose"
    >
      <el-form :model="dialogForm" :rules="dialogRules" ref="dialogForm" label-width="100px">
        <el-form-item label="角色名称" prop="name">
          <el-input v-model="dialogForm.name" placeholder="请输入角色名称" maxlength="50"></el-input>
        </el-form-item>
        <el-form-item label="角色编码" prop="code">
          <el-input v-model="dialogForm.code" placeholder="请输入角色编码" maxlength="50" :disabled="dialogForm.id !== null"></el-input>
        </el-form-item>
        <el-form-item label="描述" prop="description">
          <el-input v-model="dialogForm.description" type="textarea" :rows="3" placeholder="请输入角色描述" maxlength="255"></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="dialogForm.status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleDialogSubmit" :loading="dialogSubmitLoading">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 绑定菜单对话框 -->
    <el-dialog
      title="绑定菜单权限"
      :visible.sync="menuDialogVisible"
      width="600px"
      @close="menuDialogVisible = false"
    >
      <div class="menu-tree-wrap">
        <el-alert
          v-if="menuDialogForm.roleId === 1"
          title="超级管理员拥有全部菜单权限，无需修改"
          type="warning"
          :closable="false"
          style="margin-bottom: 16px;"
        ></el-alert>
        <el-tree
          v-else
          ref="menuTree"
          :data="menuTreeData"
          :props="{ label: 'name', children: 'children' }"
          node-key="id"
          show-checkbox
          default-expand-all
          highlight-current
          :expand-on-click-node="false"
        >
          <span slot-scope="{ node, data }" class="custom-tree-node">
            <span class="node-label">
              <i :class="data.icon || 'el-icon-menu'" style="margin-right: 6px; color: #FF8C00;"></i>
              {{ node.label }}
            </span>
            <span class="node-type">
              <el-tag v-if="data.type === 2" type="info" size="mini">操作</el-tag>
              <el-tag v-else type="warning" size="mini">菜单</el-tag>
            </span>
          </span>
        </el-tree>
      </div>
      <div slot="footer">
        <el-button @click="menuDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleMenuSubmit" :loading="menuSubmitLoading" :disabled="menuDialogForm.roleId === 1">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getRoleList,
  getRole,
  addRole,
  updateRole,
  deleteRole,
  getRoleMenus,
  bindRoleMenus,
  getMenuTree
} from '@/api'

export default {
  name: 'RoleManagement',
  data() {
    return {
      searchForm: {
        name: '',
        status: null
      },
      tableData: [],
      tableLoading: false,
      pagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },

      // 新增/编辑弹窗
      dialogVisible: false,
      dialogTitle: '新增角色',
      dialogSubmitLoading: false,
      dialogForm: {
        id: null,
        name: '',
        code: '',
        description: '',
        status: 1
      },
      dialogRules: {
        name: [{ required: true, message: '请输入角色名称', trigger: 'blur' }],
        code: [{ required: true, message: '请输入角色编码', trigger: 'blur' }]
      },

      // 绑定菜单弹窗
      menuDialogVisible: false,
      menuSubmitLoading: false,
      menuTreeData: [],
      menuDialogForm: {
        roleId: null,
        roleName: ''
      }
    }
  },
  created() {
    this.loadMenuTree()
    this.loadData()
  },
  methods: {
    async loadData() {
      this.tableLoading = true
      try {
        const params = {
          pageNum: this.pagination.pageNum,
          pageSize: this.pagination.pageSize,
          ...this.searchForm
        }
        const res = await getRoleList(params)
        this.tableData = res.data.list || []
        this.pagination.total = res.data.total || 0
      } catch (e) {
        console.error(e)
      } finally {
        this.tableLoading = false
      }
    },

    async loadMenuTree() {
      try {
        const res = await getMenuTree()
        this.menuTreeData = res.data || []
      } catch (e) {
        console.error(e)
      }
    },

    handleSearch() {
      this.pagination.pageNum = 1
      this.loadData()
    },

    handleReset() {
      this.searchForm = { name: '', status: null }
      this.handleSearch()
    },

    handlePageChange(val) {
      this.pagination.pageNum = val
      this.loadData()
    },

    // 新增
    handleAdd() {
      this.dialogTitle = '新增角色'
      this.dialogForm = { id: null, name: '', code: '', description: '', status: 1 }
      this.dialogVisible = true
    },

    // 编辑
    async handleEdit(row) {
      try {
        const res = await getRole(row.id)
        this.dialogForm = {
          id: res.data.id,
          name: res.data.name,
          code: res.data.code,
          description: res.data.description || '',
          status: res.data.status
        }
        this.dialogTitle = '编辑角色'
        this.dialogVisible = true
      } catch (e) {
        console.error(e)
      }
    },

    handleDialogClose() {
      this.$refs.dialogForm.resetFields()
    },

    async handleDialogSubmit() {
      this.$refs.dialogForm.validate(async (valid) => {
        if (!valid) return
        this.dialogSubmitLoading = true
        try {
          const { id, name, code, description, status } = this.dialogForm
          if (id) {
            await updateRole(id, { name, code, description, status })
            this.$message.success('更新成功')
          } else {
            await addRole({ name, code, description, status })
            this.$message.success('新增成功')
          }
          this.dialogVisible = false
          this.loadData()
        } catch (e) {
          console.error(e)
        } finally {
          this.dialogSubmitLoading = false
        }
      })
    },

    // 切换状态
    async handleToggleStatus(row) {
      const newStatus = row.status === 1 ? 0 : 1
      const action = newStatus === 1 ? '启用' : '禁用'
      try {
        await this.$confirm(`确定要${action}角色「${row.name}」吗？`, '提示', { type: 'warning' })
        await updateRole(row.id, { status: newStatus })
        this.$message.success(`${action}成功`)
        this.loadData()
      } catch (e) {
        if (e !== 'cancel') console.error(e)
      }
    },

    // 删除
    async handleDelete(row) {
      try {
        await this.$confirm(`确定要删除角色「${row.name}」吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        await deleteRole(row.id)
        this.$message.success('删除成功')
        this.loadData()
      } catch (e) {
        if (e !== 'cancel') console.error(e)
      }
    },

    // 绑定菜单
    async handleBindMenu(row) {
      this.menuDialogForm.roleId = row.id
      this.menuDialogForm.roleName = row.name
      this.menuDialogVisible = true
      if (row.id === 1) return

      try {
        // 加载已选中的菜单
        const res = await getRoleMenus(row.id)
        await this.$nextTick()
        this.$refs.menuTree.setCheckedKeys(res.data || [])
      } catch (e) {
        console.error(e)
      }
    },

    async handleMenuSubmit() {
      if (this.menuDialogForm.roleId === 1) return
      this.menuSubmitLoading = true
      try {
        // 同时勾选父+子节点时，只取叶子节点，避免重复
        const checked = this.$refs.menuTree.getCheckedNodes(false, true)
        const menuIds = checked.map(n => n.id)
        await bindRoleMenus(this.menuDialogForm.roleId, menuIds)
        this.$message.success('菜单绑定成功')
        this.menuDialogVisible = false
      } catch (e) {
        console.error(e)
      } finally {
        this.menuSubmitLoading = false
      }
    },

    formatDate(date) {
      if (!date) return ''
      return new Date(date).toLocaleString()
    }
  }
}
</script>

<style scoped lang="scss">
.role-management {
  padding: 20px;
}

.search-card {
  margin-bottom: 20px;
}

.table-card {
  min-height: 500px;
}

.menu-tree-wrap {
  max-height: 480px;
  overflow-y: auto;
  padding: 4px 0;
}

.custom-tree-node {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding-right: 8px;

  .node-label {
    display: flex;
    align-items: center;
    font-size: 14px;
  }

  .node-type {
    margin-left: 8px;
    flex-shrink: 0;
  }
}
</style>
